module.exports = __webpack_public_path__ + "img/bowling-pins.46df7dc4.svg";